export const dndTypes = {
  fileItem: 'FILEITEM',
};
